module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture35-0c165caf1c311d8f991278f75f82a6db.jpg";